/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Permissionid1Inputs */

const en_entity_permissionid1 = /** @type {(inputs: Entity_Permissionid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permission ID`)
};

const de_entity_permissionid1 = /** @type {(inputs: Entity_Permissionid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechtigungs-ID`)
};

/**
* | output |
* | --- |
* | "Permission ID" |
*
* @param {Entity_Permissionid1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_permissionid1 = /** @type {((inputs?: Entity_Permissionid1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Permissionid1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_permissionid1(inputs)
	return de_entity_permissionid1(inputs)
});
export { entity_permissionid1 as "entity_permissionId" }